import type { FC } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useEntityFilter } from '../../../contexts/entityFilterContext';
import { useClickOutside } from '../../../hooks/useClickOutside';
import { ChevronIcon } from '../user-menu/ChevronIcon';
import { GlobalEntityPickerPopup } from './GlobalEntityPickerPopup';

interface Props {
  entityOptions?: { value: string | undefined; label: string }[];
}

export const GlobalEntityPicker: FC<Props> = ({ entityOptions }) => {
  const { t } = useTranslation();
  const { entityIds } = useEntityFilter();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedEntityLabel, setSelectedEntityLabel] = useState<
    string | undefined
  >(entityOptions?.find((option) => option?.value === entityIds?.[0])?.label);

  const containerRef = useClickOutside<HTMLDivElement>(
    () => setIsMenuOpen(false),
    isMenuOpen
  );

  return (
    <div className={'flex items-center justify-end'} ref={containerRef}>
      <button
        className={
          'flex bg-transparent focus-visible:outline-none ' +
          'cursor-pointer transition opacity-80 hover:opacity-100 ' +
          'gap-2 border-none px-6'
        }
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label={t('selectEntity')}
      >
        <div
          className={
            'flex text-teal text-sm font-bold gap-2 font-sans text-nowrap'
          }
        >
          <span>{selectedEntityLabel || t('entity.global')}</span>
          <ChevronIcon isMenuOpen={isMenuOpen} textColor={'text-teal'} />
        </div>
      </button>

      <div
        className={`fixed top-[53px] transition-all ${isMenuOpen ? 'h-full opacity-100' : 'h-0 opacity-0'} z-[949] overflow-hidden`}
      >
        <GlobalEntityPickerPopup
          onClose={() => setIsMenuOpen(false)}
          entityOptions={entityOptions}
          setSelectedEntityLabel={setSelectedEntityLabel}
        />
      </div>
    </div>
  );
};
